import React from "react";
import Text from "components/Text";

type Props = {
  children: string;
  className?: string;
  underLine?: boolean;
  color?: string;
  fontSize?: string;
  style?: React.CSSProperties;
  fontWeight?: number | string;
};

const SubTitle = ({
  children,
  className = null,
  underLine,
  color,
  style,
  fontSize,
  fontWeight,
}: Props) => {
  let styleToInject;
  if (color || fontSize || fontWeight) {
    styleToInject = { ...style, color, fontSize, fontWeight };
  } else styleToInject = style;

  const chooseClassName = () => {
    if (underLine) {
      return `${className} subTitle-Text under-line`;
    }
    return `${className} subTitle-Text`;
  };
  return (
    <Text className={chooseClassName()} style={styleToInject}>
      {children}
    </Text>
  );
};

export default SubTitle;
